const InputKeyList = {
  quest: {
    0: ['pickup'],
    1: ['pickup', 'phone'],
    2: ['code'],
    3: ['pickup', 'dropoff', 'rideLater', 'downloadAppWeb', 'fare'],
    4: ['paymentList', 'termsAndConditions'],
    5: ['payment'],
    6: ['pickup', 'dropoff', 'accessibleVehicle', 'payment', 'fare'],
    7: ['ride'],
    8: ['receipt'],
    9: ['failed'],
    10: ['upcomingRideInfo', 'pickupDisplay', 'dropoffDisplay', 'rideLater', 'fare'],
  },
  account: {
    quest: {
      0: ['email'],
    },
    signUp: {
      0: ['name', 'email', 'password', 'rePassword'],
      1: ['downloadApp'],
    },
  },
  web: {
    0: ['phone', 'keepSignedIn', 'privacyTerms'],
    1: ['code', 'privacyTerms'],
    2: ['name', 'termsAndConditions'],
    3: ['email', 'privacyTerms'],
    4: ['password', 'rePassword', 'privacyTerms'],
    5: ['pickup', 'dropoff', 'rideLater', 'downloadAppWeb'],
    6: ['paymentList'],
    7: ['payment'],
    8: ['requestRide', 'rideType', 'driverNote', 'pickup', 'dropoff', 'fleetsProvider', 'payment'],
    9: ['confirmBook', 'pickup', 'map', 'rideTypeInput', 'payment', 'fare'],
    10: ['ride'],
    11: ['receipt'],
    12: ['failed'],
    13: ['upcomingRideInfo', 'pickupDisplay', 'dropoffDisplay', 'rideLater', 'fare'],
    14: ['rideHistory'],
    15: ['manageSmsNotification'],
    16: ['editPayment'],
  },
};

export default InputKeyList;
